import styled from '@emotion/styled'

export default styled('span')`
  color: ${props => props.theme.color.monochrome.mediumDark};
  font-size: 0.8em;
`
